import React, { useEffect } from "react";
import { HeatMapGrid } from "react-grid-heatmap";
import "../../SysGuard.scss";
import { useDispatch, useSelector } from "react-redux";
import { startCase, camelCase, isNull } from "lodash";
import { maskUsername } from "../../SysGuardCommonComp";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const UsersHeatMap = ({ isExpanded }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const sysGuardHeaderData = useSelector(
    (state) => state.SysGuardReducer.sysGuardHeaderData
  );
  const sysGuardUsersExpandedData = useSelector(
    (state) => state.SysGuardReducer.sysGuardUsersExpandedData
  );
  const userChartNonExpanded = sysGuardHeaderData?.userChart
    ? sysGuardHeaderData?.userChart
    : [];
  const userChartExpanded = sysGuardUsersExpandedData?.userChart
    ? sysGuardUsersExpandedData?.userChart
    : [];
  const userChart = isExpanded ? userChartExpanded : userChartNonExpanded;
  const heatmapData = userChart.heatmapData ? userChart.heatmapData : [];
  const heatmapDetails = userChart.heatmapDetails
    ? userChart.heatmapDetails
    : [];
  const isIncognito = useSelector((state) => state.SysGuardReducer.incognito);

  return heatmapData.length > 0 ? (
    <div className="heatMapContainer">
      <HeatMapGrid
        data={heatmapData}
        cellRender={(x, y, value) => {
          const user = heatmapDetails[x]?.[y] || {};
          const displayName = isIncognito
            ? maskUsername(user.name)
            : startCase(camelCase(user.name));
          return (
            <div
              className="heatmap-tooltip"
              title={`${displayName} has ${user.alertCount} alerts`}
              {...(isExpanded && {
                onClick: () => history.push(`/mdr/sysguard/content/Users`),
              })}
            >
              {user.abbr}
            </div>
          );
        }}
        cellStyle={(x, y, ratio) => ({
          background: heatmapDetails[x]?.[y]?.bgColor || "#000",
          fontSize: ".7rem",
          color: `#FFFFFF`,
        })}
        cellHeight={isExpanded ? "2.5rem" : "1.5rem"}
        xLabelsPos="bottom"
      />
    </div>
  ) : (
    <div className="sys-guard-user-expanded-graph-container">
      <div>No Data Available</div>
    </div>
  );
};

export default UsersHeatMap;
